var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('date-picker',_vm._b({ref:"datepicker",attrs:{"valueType":"format","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}},nativeOn:{"click":function($event){$event.stopPropagation();}}},'date-picker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }